module.exports = __webpack_public_path__ + "img/vulcans1.1f9b0df.jpg";